import React, { useContext, useEffect, useState } from 'react';
import { StyleSheet, Text, View, TouchableOpacity, Alert, FlatList, Modal, TextInput, Dimensions, StatusBar, ActivityIndicator, Platform, AppState, Permission, PermissionsAndroid } from 'react-native';
import TcpSocket from 'react-native-tcp-socket';
import {NetworkInfo} from 'react-native-network-info';
import NetInfo from "@react-native-community/netinfo";
import AndroidOpenSettings from 'react-native-android-open-settings'
import WifiManager, { forceWifiUsageWithOptions } from "react-native-wifi-reborn";

// import 'react-native-gesture-handler'

import { AntDesign, Entypo, Ionicons, MaterialCommunityIcons  } from '@expo/vector-icons';

import AsyncStorage from '@react-native-async-storage/async-storage';
import { CredentialsContext } from '../components/CredentialsContext';

import axios from 'axios';

import Card from '../components/Card';
import StyledText from '../components/StyledText';
import BoldStyledText from '../components/BoldStyledText';

import { EnglishStrings } from '../strings/English';
import { PersianStrings } from '../strings/Persian';
import { ArabicStrings } from '../strings/Arabic';

import envVars from '../env';

const Home = props => {

    const {storedCredentials, setStoredCredentials} = useContext(CredentialsContext);

    const [appState, setAppState] = useState(AppState.currentState)

    let fetchRoomsIsSubscribed = true

    const [mcIsSent, setMcIsSent] = useState(false)

    const [rooms, setRooms] = useState(()=> {
        if(typeof storedCredentials.userRooms == 'string') return JSON.parse(storedCredentials.userRooms)
        else return storedCredentials.userRooms
    });
    const [setRoomsHelper, setSetRoomsHelper] = useState(0)

    const fetchUserRooms = () =>{
        const url = envVars.SERVER_URL + envVars.SERVER_PORT + '/users/fetchRooms';
        const parsedUserDevicesInfo = JSON.parse(storedCredentials.userDevicesInfo);

        const credentials = { 
            userPhoneNumber: storedCredentials.userPhoneNumber,
            userDeviceID: parsedUserDevicesInfo[0].id,
            userDeviceInfo: parsedUserDevicesInfo[0].name,
        };
        
        
        axios.post(url, credentials)
        .then((res)=> {
            const result = res.data;
            const { message, status, data} = result;

            AsyncStorage.getItem('flowerCribCredentials').then((storedData)=> {
                storedData = JSON.parse(storedData);
                storedData.userRooms = data.userRooms;
                var tempStoredData = storedData
                if(data.userInfo.customModulesNames){
                    tempStoredData = {...storedData, ...{customModulesNames: data.userInfo.customModulesNames}, ...{customSwitchesIcons: data.userInfo.customSwitchesIcons}, ...{senarios: data.userInfo.senarios}}
                }
                
                AsyncStorage.setItem('flowerCribCredentials', JSON.stringify(tempStoredData));
                setStoredCredentials(tempStoredData)
                if(fetchRoomsIsSubscribed) setRooms(storedData.userRooms);
            })
            .catch((err) => console.log(err))
            
        })
        .catch((err)=> {
            // if(Platform.OS == 'web') {
            //     window.alert("")
            // } else {
            //     Alert.alert(
            //         strings().error,
            //         strings().anErrorOccurredPleaseCheckInternetConnection,
            //         [{
            //             text: strings().ok
            //         }]
            //     );
            // }
        });
    };

    const [modules, setModules] = useState(() => {
        //console.log("ROOMS:", rooms.length)
        if(rooms){
            var tempModules = []
            rooms.forEach(room => {
                room.modules.forEach(module => {
                    tempModules.push(module)
                })
            });
            
            return tempModules
        } else {
            return []
        }
    })

    const [setModulesHelper, setSetModulesHelper] = useState(0)

    const [recieveCode, setRecieveCode] = useState('');
    const [isFetchingRecieveCode, setIsFetchingRecieveCode] = useState(false);
    const [isUpdating, setIsUpdating] = useState(true);

    const [dropdownModalVisible, setDropdownModalVisible] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [manualAddRoomModalVisible, setManualAddRoomModalVisible] = useState(false);

    const [recieveRoomModalVisible, setRecieveRoomModalVisible] = useState(false);
    const [sendRoomModalVisible, setSendRoomModalVisible] = useState(false);
    const [recieverCode, setRecieverCode] = useState('');

    const [newRoomName, setNewRoomName] = useState('');

    const [isEditingMode, setIsEditingMode] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const [selectedItemsHelper, setSelectedItemsHelper] = useState(0);

    const [isSendingRooms, setIsSendingRooms] = useState(false);
    const [isDeletingRooms, setIsDeletingRooms] = useState(false);

    const [socketReadyState, setSocketReadyState] = useState(props.socket.readyState)

    var updateInterval;
    var setIsUpdatingToFalseHandlerInterval;
    var waitingForResInterval;
    var updateReqsInterval;
    var askForTurningWifiOn = true

    const strings = () => {
        if(storedCredentials.language == 'English') {
            return EnglishStrings
        } else if(storedCredentials.language == 'Arabic') {
            return ArabicStrings
        } else return PersianStrings
    }

    var userMACsArr = () => {
        var MACsArr = [];
        rooms.forEach(room => {
            room.modules.forEach(module => {
                var roomModule = {MACs: [], orgDID: ""}
                if(module) roomModule.MACs.push(module.MAC)
    
                if(module && module.orgDID) roomModule.orgDID = module.orgDID
                else delete roomModule.orgDID
                
                if(roomModule.MACs.length > 0) MACsArr.push(roomModule)
            })
            

        });

        // console.log('USERMACSARR: ', MACsArr)

        return MACsArr

    } 

    const setIsUpdatingToFalseHandler = (updateReqsLength) => {
        if(!setIsUpdatingToFalseHandlerInterval) {
            setIsUpdating(true)
            const timer = updateReqsLength * 100
            setIsUpdatingToFalseHandlerInterval = setInterval(() => { 
                setIsUpdating(false) 
                clearInterval(setIsUpdatingToFalseHandlerInterval)
                setIsUpdatingToFalseHandlerInterval = undefined
            },  timer)
        }
    }

    const updateModulesHandler = (MACsArr) => {
        setIsUpdatingToFalseHandler(MACsArr.length)
        var tempToken = ""
        AsyncStorage.getItem('flowerCribCredentials')
        .then((result)=>{
            if(result !== null){
                const parsedResult = JSON.parse(result)
                tempToken = parsedResult.token
            }
        })
        
        
        const onlineUpdate = (MACsArr) => {
            var updateReqs = [];

            MACsArr.forEach(arrItem=> {
                if(arrItem.orgDID) {
                    updateReqs.push(
                        {
                            CTY : 'mgs',
                            MACs: arrItem.MACs,
                            DID: storedCredentials.userPhoneNumber,
                            orgDID: arrItem.orgDID,
                            token: tempToken
                        }
                    )
                } else {
                    updateReqs.push(
                        {
                            CTY : 'mgs',
                            MACs: arrItem.MACs,
                            DID: storedCredentials.userPhoneNumber,
                            token: tempToken
                        }
                    )
                }
            })
            
            var intervalIndex = 0
            updateReqsInterval = setInterval(() => {
                props.socket.sendMessage(JSON.stringify(updateReqs[intervalIndex]))
                
                if(intervalIndex == updateReqs.length - 1) clearInterval(updateReqsInterval)
                intervalIndex++
            },200)

        }

        const offlineUpdate = () => {
            NetworkInfo.getIPAddress().then(ipAddress => {
                // console.log("LOCALIP: ", ipAddress)
                if(ipAddress) {
                    const splitedLocalIp = ipAddress.split(".")
                    // console.log("Splited IP: ", splitedLocalIp)
    
                    var localConnected = false
                    // console.log('Starting OFFLINE...')
                    modules.forEach(module => {
    
                        var updateReq
                        if(module.orgDID) {
                            updateReq = {
                                CTY : 'mgs',
                                DID: module.orgDID,
                                DIR: storedCredentials.userPhoneNumber
                            }
                        } else {
                            updateReq = {
                                CTY : 'mgs',
                                DID: storedCredentials.userPhoneNumber,
                                DIR: storedCredentials.userPhoneNumber
                            }
                        }
            
                        const moduleSplitedIp = module.localIp.split(".")
                        
                        if(moduleSplitedIp[0] == splitedLocalIp[0] && moduleSplitedIp[1] == splitedLocalIp[1] && moduleSplitedIp[2] == splitedLocalIp[2]) {
                            // console.log("IP: ", module.localIp)
                            localConnected = true
                            const client = TcpSocket.createConnection({port: 9999, host: module.localIp, timeout: 10000}, ()=> {
                                // console.log("SOCKET OPENED!")
                                client.write(JSON.stringify(updateReq));
                                
                            })  
    
                            client.on('timeout', ()=> {
                                // console.log(module.localIp, "Timedout, destroying...")
                                client.destroy()
                                setIsUpdating(false)
                            })
                
                            client.on('error', (err)=> {
                                // console.log("ERROR: ", err)
                                client.destroy()
                                setIsUpdating(false)
                            })
                
                            client.on('data', function(data) {
                                var res = "";
                                data.map(charCode=> res = res + String.fromCharCode(charCode))
                                const parsedData = JSON.parse(res)    
                    
                                if(parsedData.CTY == "mgsRes" && parsedData.STM) {
                                    setIsUpdating(false);
                                    const index = modules.findIndex(module => module.MAC == parsedData.MAC)
                                    const newState = {STM: parsedData.STM, RTM: parsedData.RTM, FAN: parsedData.FAN, MOD: parsedData.MOD, PWR: parsedData.PWR}
                                    const updatedModule = {...modules[index], ...{newState}, ...{isWaitingForRes: false}}
                                    clearInterval(updateInterval)
                                    var updatedModules = modules;
                                    updatedModules[index] = {...updatedModules[index], ...updatedModule}
                                    setModules(updatedModules)
                                    setSetModulesHelper(setModulesHelper => setModulesHelper + 1)
                    
                                    // console.log(updatedModules)
                    
                                } else if(parsedData.CTY == "mgsRes" && !parsedData.STM) {
                                    setIsUpdating(false)
                                    // console.log(parsedData.STM)
                                    const index = modules.findIndex(module => module.MAC == parsedData.MAC)
                                    const updatedModule = {...modules[index], ...{newState: parsedData.STA}, ...{isWaitingForRes: false}}
                                    clearInterval(updateInterval)
                                    var updatedModules = modules;
                                    updatedModules[index] = {...updatedModules[index], ...updatedModule}
                                    setModules(updatedModules)
                                    setSetModulesHelper(setModulesHelper => setModulesHelper + 1)
                                    
                                    // console.log(updatedModules)
                                }
                                
                            })
    
                        }
                        
                    })

                }
                // if(!localConnected){
                //     clearInterval(updateInterval)
                //     if(MACsArr.length) {
                //         console.log("GOING ONLINE...")
                //         onlineUpdate(MACsArr);
                //     }
                // }
            });
                
        }

        NetInfo.fetch().then(state => {
            // console.log("Connection type", state.type);
            // console.log("Is connected?", state.isConnected);

            if(state.isConnected) {
                if(MACsArr.length) {
                    onlineUpdate(MACsArr);
                }
            } else {
                if(Platform.OS != 'web'){
                    offlineUpdate();
                }
            }
        });

    }

    const openWifiSettings = () => {
        AndroidOpenSettings.wifiSettings()
    }

    const generatePassword = ssid => {
        const middleChars = ssid.substring(6, 10);
        const modifiedString = middleChars.substring(0, 2) + ':' + middleChars.substring(2);

        var MAC = ''
        storedCredentials.userRooms.forEach(room => {
            room.modules.forEach(module => {
                if(module.MAC.slice(-5) === modifiedString){
                    MAC = module.MAC
                }
            })
        })

        const pass = MAC + '@zitP'
        return pass
        
    }

    const askForTurningWifiOnHandlerFunc = () => {
        askForTurningWifiOn = false
    }

    const checkForNearbyModule = async (opt) => {
        if(opt){
            console.log(opt);
        }
        if(storedCredentials.offlineUsage){
            const isWifiEnabled = await WifiManager.isEnabled()
            if(isWifiEnabled) {
                try{
                    const granted = await PermissionsAndroid.request(
                        PermissionsAndroid.PERMISSIONS.ACCESS_FINE_LOCATION,
                        {
                            title: strings().requestForWifiPermission,
                            message: strings().ZitkitNeedsThisPermissionToConnectToYourSmartSwitch,
                            buttonNeutral: strings().notNow,
                            buttonNegative: strings().notAllowed,
                            buttonPositive: strings().Allowed
                        },
                    )
        
                    if(granted == PermissionsAndroid.RESULTS.GRANTED){
                        WifiManager.reScanAndLoadWifiList().then(wifiList => {
                            console.log("WifiList: ", wifiList)
                            if(wifiList.length) {
                                // console.log('founded networks:', wifiList.length)
                                const updatedStoredCredentials = {...storedCredentials, ...{wifiNetworks: wifiList}}

                                AsyncStorage.setItem('flowerCribCredentials', JSON.stringify(updatedStoredCredentials))
                                .then(()=> {
                                    setStoredCredentials(updatedStoredCredentials)
                                })
                                .catch(err =>{
                                    console.log("err23: ",err);
                                })        
                                
                                wifiList.forEach(wifiNetwork => {
                                    if(wifiNetwork.SSID.substring(0, 6) === 'Zitco_'){
                                        const psl = generatePassword(wifiNetwork.SSID)
                                        // console.log('lss: ', wifiNetwork.SSID)
                                        // console.log('psl: ', psl)
                                        WifiManager.connectToProtectedSSID(wifiNetwork.SSID, psl, false).then(
                                            () => {
                                                console.log("Connected!")
                                            },
                                            (err) => {
                                                console.log('ask for connecting turned off')
                                                console.log(err)
                                                askForTurningWifiOnHandlerFunc()
                                            }
                                        )
                                        // return
                                    }
                                })
    
                            }
                        }).catch(err =>{
                            console.log('err: ', err)
                            Alert.alert(
                                "",
                                strings().pleaseTurnOnLocationService,
                                [{
                                    text: strings().ok,
                                    onPress: () => { 
                                        AndroidOpenSettings.locationSourceSettings()
                                    }
                                }]
                            );
                    })
                    } else {
                        Alert.alert(
                            "",
                            strings().permissionDenied,
                            [{
                                text: strings().ok
                            }]
                        );            
                    }
                } catch(err) {
                    console.log("2: ", err)
                }
            } else {
                Alert.alert(
                    '',
                    strings().toUseOfflineUsageYouShouldEnableWifi,
                    [
                        { text: strings().deny, style: 'cancel' , onPress: askForTurningWifiOnHandlerFunc},
                        { text: strings().ok, onPress: openWifiSettings }
                    ],
                    { cancelable: false}
                )
            }

        } else if(opt === 'button'){
            Alert.alert(
                '',
                strings().toUseOfflineUsageYouShouldEnableWifi,
                [
                    { text: strings().deny, style: 'cancel' , onPress: askForTurningWifiOnHandlerFunc},
                    { text: strings().ok, onPress:  props.navigation.navigate('Settings') }
                ],
                { cancelable: false}
            )
        }
    
    }
    
    useEffect(() => {
        if(storedCredentials.offlineUsage){
            // WifiManager.forceWifiUsage(false)
            checkForNearbyModule()
        }
    },[])

    useEffect(() => {
        const subscription = AppState.addEventListener('change', state => {
            if(appState === 'active' && storedCredentials.offlineUsage && askForTurningWifiOn){
                WifiManager.getCurrentWifiSSID().then(ssid => {
                    // console.log('ssid:', ssid)
                    if(ssid.substring(0,6) !== 'Zitco_'){
                        checkForNearbyModule()
                    }
                }).catch(err => { 
                    console.log('err22:',err)
                    // checkForNearbyModule()
                })
            }
        })

        return () => {
            subscription.remove()
        }
    
    },[])

    useEffect(() => {       
        // console.log(storedCredentials)
        fetchUserRooms();
    },[])

    useEffect(() => {
        setSocketReadyState(props.socket.readyState)
    },[props.socket.readyState])

    //Handeling modules response
    useEffect(()=> {
        if(props.socket.lastMessage) {
            const parsedData = props.socket.lastMessage     
            if(parsedData.CTY) {
                if(parsedData.CTY == "mgsRes" && parsedData.STM) {
                    // setIsUpdating(false)
                    const index = modules.findIndex(module => module.MAC == parsedData.MAC)
                    const newState = {STM: parsedData.STM, RTM: parsedData.RTM, FAN: parsedData.FAN, MOD: parsedData.MOD, PWR: parsedData.PWR}
                    const updatedModule = {...modules[index], ...{newState}, ...{isWaitingForRes: false}}
                    var updatedModules = modules;
                    updatedModules[index] = {...updatedModules[index], ...updatedModule}
                    setModules(updatedModules)
                    setSetModulesHelper(setModulesHelper => setModulesHelper + 1)
                } else if(parsedData.CTY == "mgsRes" && !parsedData.STM) {
                    // setIsUpdating(false)
                    const index = modules.findIndex(module => module.MAC == parsedData.MAC)
                    const updatedModule = {...modules[index], ...{newState: parsedData.STA}, ...{isWaitingForRes: false}}
                    var updatedModules = modules;
                    updatedModules[index] = {...updatedModules[index], ...updatedModule}
                    setModules(updatedModules)
                    setSetModulesHelper(setModulesHelper => setModulesHelper + 1)
                }

            }

        }

    }, [props.socket.lastMessage])
    
    useEffect(()=> {
        props.navigation.setOptions({
            headerTitle: () => (
                <View style={{flexDirection: 'row'}}>
                    {props.isTokenValidated ?     
                        <>
                            <BoldStyledText style={{fontSize: isUpdating ? 25 : 35, color: storedCredentials.theme == 'light' ? 'blue' : '#e88804'}}> {isUpdating ? strings().updating : strings().places} </BoldStyledText>
                            {isUpdating && <ActivityIndicator size={'small'} color={ storedCredentials.theme == 'light' ? 'blue' : '#e88804' } /> }
                        </>
                    :
                        <>
                            <BoldStyledText style={{fontSize: isUpdating ? 25 : 35, color: storedCredentials.theme == 'light' ? 'blue' : '#e88804'}}> {strings().connecting} </BoldStyledText>
                            <ActivityIndicator size={'small'} color={ storedCredentials.theme == 'light' ? 'blue' : '#e88804' } />
                        </>
                    }
                    
                </View>
            ),
            headerTitleAlign: 'center',
            headerTitleStyle:{
                fontSize: isUpdating ? 25 : 35,
                // fontFamily: "Mikhak-Bold"
            },
            headerStyle:{
                backgroundColor: storedCredentials.theme == "light" ? '#f2f2f2' : '#3b3c37' 
            },
            headerRight: () => (
                <View style={{justifyContent: 'center'}}>
    
                    <TouchableOpacity 
                        style={{paddingRight: 17}}
                        onPress={()=>{
                            toggleDropdownModal();
                            setSelectedItems([]);
                            // console.log(storedCredentials)
                        }}
                    >
                        <Entypo name="menu" size={35} color={storedCredentials.theme == "light" ? 'black' : 'white' } />
    
                    </TouchableOpacity>
                </View>
            ),
            headerLeft: () => (
                <View style={{justifyContent: 'center'}}>
    
                    <TouchableOpacity 
                        style={{paddingLeft: 17}}
                        onPress={()=>{
                            setModalVisible(!modalVisible)
                            setIsUpdating(false)
                        }}
                    >
                        <Ionicons name="add-circle-outline" size={40} color={storedCredentials.theme == "light" ? 'black' : 'white' } />
    
                    </TouchableOpacity>
                </View>
            ),
            headerTintColor: storedCredentials.theme == "light" ? 'black' : 'white' 
        })
    },[isUpdating])

    // useEffect(()=> {
    //     console.log('isSokectValidated? ', props.isTokenValidated)

    //     if(props.isTokenValidated) {
    //         fetchUserRooms(); 
    //         updateModulesHandler(userMACsArr());
    //     } 

    // }, [props.isTokenValidated])

    useEffect(() => {
        const isFocused = props.buttomNavNavigation.addListener('focus', () => {
            var denewstatedModules = []
            var tempRooms = rooms
            tempRooms.forEach(room => {
                room.modules.forEach(module => {
                    if(module.newState) {
                        delete module.newState 
                        denewstatedModules.push(module)
                    } else denewstatedModules.push(module) 
                })
            })
            
            setModules(denewstatedModules)
            setSetModulesHelper(setModulesHelper => setModulesHelper + 1)

            fetchUserRooms();
            updateModulesHandler(userMACsArr())
        })

        return isFocused
    },[props.buttomNavNavigation])
    
    // useEffect(()=> {
    //     const focusedListener = props.navigation.addListener('focus', () => {
    //         var denewstatedModules = []
    //         var tempRooms = rooms
    //         tempRooms.forEach(room => {
    //             room.modules.forEach(module => {
    //                 if(module.newState) {
    //                     delete module.newState 
    //                     denewstatedModules.push(module)
    //                 } else denewstatedModules.push(module) 
    //             })
    //         })
            
    //         setModules(denewstatedModules)
    //         setSetModulesHelper(setModulesHelper => setModulesHelper + 1)

    //         fetchUserRooms();
    //         updateModulesHandler(userMACsArr())
    //         // AsyncStorage.getItem('flowerCribCredentials').then((storedData)=> {
    //         //     storedData = JSON.parse(storedData)
    //         //     if(storedData.token != ""){
    //         //         updateModulesHandler(userMACsArr());
    //         //     } 
    //         // })
            
            
    //     });

    //     return focusedListener
        
    // },[props.navigation])

    useEffect(() => {
        if(selectedItems.length == 0) {
            setIsEditingMode(false);
        }
    },[selectedItemsHelper])

    const openMenu = () => setPaperVisible(true);
    const closeMenu = () => setPaperVisible(false);
    const screenHeight = Dimensions.get('screen').height;
    const windowHeight = Dimensions.get('window').height;
    const navbarHeight = screenHeight - windowHeight ;

    const logout = () =>{

        const url = envVars.SERVER_URL + envVars.SERVER_PORT + '/signout';
        const parsedUserDevicesInfo = JSON.parse(storedCredentials.userDevicesInfo);
        
        const credentials = { 
            userPhoneNumber: storedCredentials.userPhoneNumber,
            userDeviceID: parsedUserDevicesInfo[0].id,
            userDeviceInfo: parsedUserDevicesInfo[0].name
        }

        axios.post(url, credentials)
        .then((res)=> {
            const result = res.data;
            const { message, status, data} = result;
            
            if(status == 'SUCCESS'){
                AsyncStorage.removeItem('flowerCribCredentials')
                .then(()=> {
                    setStoredCredentials("");
                })
                .catch(err => console.log(err));
            };

        })
        .catch((err)=> {
            if(Platform.OS == 'web') {
                window.alert(strings().anErrorOccurredPleaseCheckInternetConnection)
            } else {
                Alert.alert(
                    strings().error,
                    strings().anErrorOccurredPleaseCheckInternetConnection,
                    [{
                        text: strings().ok
                    }]
                );
            }
        });
   

    };

    const handleAddNewRoom = () => {
        if(newRoomName == '') {
            if(Platform.OS == 'web') {
                window.confirm(strings().pleaseEnterRoomName)
            } else {
                Alert.alert(
                    strings().error,
                    strings().pleaseEnterRoomName,
                    [{
                        text: strings().ok
                    }]
                );
            }

        } else {
            const url = envVars.SERVER_URL + envVars.SERVER_PORT + '/users/addroom';
            const parsedUserDevicesInfo = JSON.parse(storedCredentials.userDevicesInfo);
            // console.log(storedCredentials)
    
            const credentials = { 
                userPhoneNumber: storedCredentials.userPhoneNumber,
                userDeviceID: parsedUserDevicesInfo[0].id,
                userDeviceInfo: parsedUserDevicesInfo[0].name,
                userNewRoom: newRoomName
            }
    
    
            axios.post(url, credentials)
            .then((res)=>{
                const result = res.data;
                const { message, status, data} = result;
    
                AsyncStorage.getItem('flowerCribCredentials').then((storedData)=> {
                    storedData = JSON.parse(storedData);
    
                    storedData.userRooms = data[0].userRooms;
    
                    AsyncStorage.setItem('flowerCribCredentials', JSON.stringify(storedData));
                    setRooms(storedData.userRooms);
                })
    
                setManualAddRoomModalVisible(!manualAddRoomModalVisible);
            })
            .catch((err)=>{
                if(Platform.OS == 'web') {
                    window.confirm(strings().anErrorOccurredPleaseCheckInternetConnection)
                } else {
                    Alert.alert(
                        strings().error,
                        strings().anErrorOccurredPleaseCheckInternetConnection,
                        [{
                            text: strings().ok
                        }]
                    );
                }
            })

        }
    }

    const toggleDropdownModal = () => {
        setDropdownModalVisible(!dropdownModalVisible)
    }

    const toggleSelecteItem = itemData => {
        if(!isEditingMode){
            setIsEditingMode(true);
        }
        const selectedItemsArr = selectedItems;
        const index = selectedItemsArr.findIndex(item => item == itemData.item.id)
        if(index == -1){
            selectedItemsArr.push(itemData.item.id);
            setSelectedItems(selectedItemsArr);
            setSelectedItemsHelper(selectedItemsHelper + 1)
        } else {
            selectedItemsArr.splice(index, 1);
            setSelectedItems(selectedItemsArr);
            setSelectedItemsHelper(selectedItemsHelper + 1)
        }

    }

    const fetchRecieveCodeHandler = () => {
        const url = envVars.SERVER_URL + envVars.SERVER_PORT + '/users/recieveCodeReq';
        const parsedUserDevicesInfo = JSON.parse(storedCredentials.userDevicesInfo);
        
        const credentials = { 
            userPhoneNumber: storedCredentials.userPhoneNumber,
            userDeviceID: parsedUserDevicesInfo[0].id,
            userDeviceInfo: parsedUserDevicesInfo[0].name
        }

        
        axios.post(url, credentials)
        .then((res)=> {
            const result = res.data;
            const { message, status, data} = result;

            if(status == 'SUCCESS') {
                setRecieveCode(data.userRecieveCode);
                setIsFetchingRecieveCode(false);
            } else {
                if(Platform.OS == 'web') {
                    window.alert(strings().anErrorOccurredPleaseCheckInternetConnection)
                } else {
                    Alert.alert(
                        strings().error,
                        strings().anErrorOccurredPleaseCheckInternetConnection,
                        [{
                            text: strings().ok
                        }]
                    );
                }
            }       
        })
        .catch((err)=> {
            if(Platform.OS == 'web') {
                window.alert(strings().anErrorOccurredPleaseCheckInternetConnection)
            } else {
                Alert.alert(
                    strings().error,
                    strings().anErrorOccurredPleaseCheckInternetConnection,
                    [{
                        text: strings().ok
                    }]
                );
            }
        });
        
    }

    const removeRecieveCode = () => {
        const url = envVars.SERVER_URL + envVars.SERVER_PORT + '/users/removeRecieveCodeReq';
        const parsedUserDevicesInfo = JSON.parse(storedCredentials.userDevicesInfo);
        
        const credentials = { 
            userPhoneNumber: storedCredentials.userPhoneNumber,
            userDeviceID: parsedUserDevicesInfo[0].id,
            userDeviceInfo: parsedUserDevicesInfo[0].name
        }

        
        axios.post(url, credentials)
        .then((res)=> {
            const result = res.data;
            const { message, status} = result;

            if(status == 'SUCCESS') {
                setRecieveRoomModalVisible(false);
            } else {
                if(Platform.OS == 'web') {
                    window.alert(strings().anErrorOccurredPleaseCheckInternetConnection)
                } else {
                    Alert.alert(
                        strings().error,
                        strings().anErrorOccurredPleaseCheckInternetConnection,
                        [{
                            text: strings().ok
                        }]
                    );
                }
            }       
        })
        .catch((err)=> {
            if(Platform.OS == 'web') {
                window.alert(strings().anErrorOccurredPleaseCheckInternetConnection)
            } else {
                Alert.alert(
                    strings().error,
                    strings().anErrorOccurredPleaseCheckInternetConnection,
                    [{
                        text: strings().ok
                    }]
                );
            }
        });
    }

    const finishSendingRoomsHandler = () => {
        setIsSendingRooms(false);
        setIsDeletingRooms(false)
        setIsEditingMode(false);
        setSelectedItems([]);
        setSelectedItemsHelper(1);
        setSendRoomModalVisible(false)
    }

    const sendRoomHandler = () => {
        if(recieveCode.length < 6) {
            if(Platform.OS == 'web') {
                window.alert(strings().pleaseEnterTargetUserCode)
            } else {

                Alert.alert(
                    "",
                    strings().pleaseEnterTargetUserCode,
                    [{
                        text: strings().ok
                    }]
                );
            }

        } else {
            setIsSendingRooms(true)
            
            const url = envVars.SERVER_URL + envVars.SERVER_PORT + '/users/shareRooms';
            const parsedUserDevicesInfo = JSON.parse(storedCredentials.userDevicesInfo);
        
            const credentials = { 
                userPhoneNumber: storedCredentials.userPhoneNumber,
                userDeviceID: parsedUserDevicesInfo[0].id,
                userDeviceInfo: parsedUserDevicesInfo[0].name,
                targetUserRecieveCode: recieveCode,
                roomsToShare: JSON.stringify(selectedItems)
            };
            
            axios.post(url, credentials)
            .then((res)=> {
                const result = res.data;
                const { message, status, data} = result;
    
                if(status == 'SUCCESS') {
                    // console.log(result);

                    if(Platform.OS == 'web') {
                        const res = window.alert(strings().selectedRoomsSentSuccessfully)
                        finishSendingRoomsHandler()
                    } else {
                        Alert.alert(
                            "",
                            strings().selectedRoomsSentSuccessfully,
                            [{
                                text: strings().ok,
                                onPress: ()=> finishSendingRoomsHandler()
                            }]
                        );
                    }
                } else if (message == 'User with provided recieve code did not found!') {
                    if(Platform.OS == 'web') {
                        window.alert(strings().userWithProvidedCodeDidNotFound)
                        finishSendingRoomsHandler()
                    } else {
                        Alert.alert( 
                            strings().error,
                           strings().userWithProvidedCodeDidNotFound,
                            [{
                                text: strings().ok,
                                onPress: ()=> finishSendingRoomsHandler()
                            }]
                        ); 
                    }
                } else {
                    if(Platform.OS == 'web') {
                        window.confirm(strings().anErrorOccurredPleaseCheckInternetConnection)
                        finishSendingRoomsHandler()
                    } else {
                        Alert.alert(
                            strings().error,
                            strings().anErrorOccurredPleaseCheckInternetConnection,
                            [{
                                text: strings().ok,
                                onPress: ()=> finishSendingRoomsHandler()
                            }]
                        );
                    }
                }       
            })
            .catch((err)=> {
                if(Platform.OS == 'web') {
                    window.alert(strings().anErrorOccurredPleaseCheckInternetConnection)
                    finishSendingRoomsHandler()
                } else {
                    Alert.alert(
                        strings().error,
                        strings().anErrorOccurredPleaseCheckInternetConnection,
                        [{
                            text: strings().ok,
                            onPress: ()=> finishSendingRoomsHandler()
                        }]
                    );
                }
            });
    
        }
        
    }

    const deleteRoomsHandler = () => {
        setIsDeletingRooms(true)
            
        const url = envVars.SERVER_URL + envVars.SERVER_PORT + '/users/deleteRooms';
        const parsedUserDevicesInfo = JSON.parse(storedCredentials.userDevicesInfo);
    
        const credentials = { 
            userPhoneNumber: storedCredentials.userPhoneNumber,
            roomsToDelete: JSON.stringify(selectedItems)
        };
        
        axios.post(url, credentials)
        .then((res)=> {
            const result = res.data;
            const { message, status, data} = result;

            if(status == 'SUCCESS') {
                finishSendingRoomsHandler();
                fetchUserRooms();
            } else {
                if(Platform.OS == 'web') {
                    window.confirm(strings().anErrorOccurredPleaseCheckInternetConnection)
                    finishSendingRoomsHandler()
                } else {
                    Alert.alert(
                        strings().error,
                        strings().anErrorOccurredPleaseCheckInternetConnection,
                        [{
                            text: strings().ok,
                            onPress: ()=> finishSendingRoomsHandler()
                        }]
                    );
                }
            }       
        })
        .catch((err)=> {
            if(Platform.OS == 'web') {
                window.alert(strings().anErrorOccurredPleaseCheckInternetConnection)
                finishSendingRoomsHandler()
            } else {
                Alert.alert(
                    strings().error,
                    strings().anErrorOccurredPleaseCheckInternetConnection,
                    [{
                        text: strings().ok,
                        onPress: ()=> finishSendingRoomsHandler()
                    }]
                );
            }
        });

    }

    const gotoRoomModulesHandler = (itemData) => {
        clearInterval(updateReqsInterval)
        clearInterval(waitingForResInterval)

        props.navigation.navigate('Room Modules', {itemData: { item: itemData.item } })
    }

    const cardModulesArrHandler = (roomID) => {
        const index = rooms.findIndex(room => room.id == roomID)
        var roomModulesArr = []
        rooms[index].modules.forEach(storedModule => {
            const index = modules.findIndex(module => module.MAC == storedModule.MAC)
            if(index != -1) roomModulesArr.push(modules[index])
        })

        return roomModulesArr
    }

    return(
        // <View style={Styles.wrapper}>
        <View style={ storedCredentials.theme == 'light' ? LightStyles.wrapper :  DarkStyles.wrapper }>
            <StatusBar />
            <Modal
                transparent = {true}
                visible = {dropdownModalVisible}
                onRequestClose={() => setDropdownModalVisible(false)}
            >
                <TouchableOpacity 
                    style={{flex: 1, marginTop: (navbarHeight/2), alignItems: 'flex-end'}}
                    onPress={() => toggleDropdownModal()}
                    activeOpacity= {1}
                >
                    {/* <View style={{backgroundColor: 'pink', padding: 10, width: '50%', marginRight: 15, borderRadius: 15}}> */}
                    <View style={ storedCredentials.theme == 'light' ? LightStyles.dropdownModalWrapper :  DarkStyles.dropdownModalWrapper }>
                        
                        <View style={{margin: 5}}>
                            <StyledText style={{fontSize: 18, fontWeight: '400'}}> {storedCredentials.userPhoneNumber} </StyledText>
                        </View>

                        <View style={{backgroundColor: 'gray', height: 2}}/>

                        <TouchableOpacity style={{margin: 5}}
                            onPress={() => {
                                toggleDropdownModal();
                                setRecieveRoomModalVisible(true)
                                fetchRecieveCodeHandler();
                                setIsFetchingRecieveCode(true);
                            }}
                        >
                            <StyledText style={{fontSize: 22, fontWeight: '400'}}> {strings().receivePlace} </StyledText>
                        </TouchableOpacity>

                        <View style={{backgroundColor: 'gray', height: 2}}/>

                        <TouchableOpacity style={{margin: 5}} onPress={()=> {
                            props.navigation.navigate('Settings');
                            toggleDropdownModal();
                        }}>
                            <StyledText style={{fontSize: 22, fontWeight: '400'}}> {strings().settings} </StyledText>
                        </TouchableOpacity>
                        
                        <View style={{backgroundColor: 'gray', height: 2}}/>

                        {Platform.OS !== 'web' && 
                            <>
                                <TouchableOpacity style={{margin: 5}} onPress={()=> {
                                    checkForNearbyModule('button');
                                    toggleDropdownModal();
                                }}>
                                    <StyledText style={{fontSize: 22, fontWeight: '400'}}> {strings().search} </StyledText>
                                </TouchableOpacity>
        
                                <View style={{backgroundColor: 'gray', height: 2}}/>
                            </>
                        }

                        <TouchableOpacity style={{margin: 5}} onPress={logout} >
                            <StyledText style={{fontSize: 22, fontWeight: '400'}}> {strings().logOut} </StyledText>
                        </TouchableOpacity>

                        <View style={{backgroundColor: 'gray', height: 2}}/>

                        <TouchableOpacity style={{margin: 5}} >
                            {/* <StyledText style={{fontSize: 22, fontWeight: '400'}}> v0.8.1.0 (Beta) </StyledText> */}
                            <StyledText style={{fontSize: 22, fontWeight: '400'}}> v1.3.9 </StyledText>
                        </TouchableOpacity>
                    </View>
                </TouchableOpacity>
            </Modal>
            <Modal 
                animationType = 'fade'
                transparent = {true}
                visible = {modalVisible}
                onRequestClose = {() => setModalVisible(!modalVisible)}
                >
                <View style={{flex: 1, justifyContent: 'center'}}>
                    <View style={storedCredentials.theme == 'light' ? LightStyles.modalView :  DarkStyles.modalView}>
                        <View style={storedCredentials.theme == 'light' ? LightStyles.modalHeader :  DarkStyles.modalHeader}>
                            <TouchableOpacity 
                                style={storedCredentials.theme == 'light' ? LightStyles.modalHeaderCloseIconWrapper :  DarkStyles.modalHeaderCloseIconWrapper} 
                                onPress={()=> setModalVisible(!modalVisible)}
                                >
                                <AntDesign name="closecircleo" size={24} color="white" />                            
                            </TouchableOpacity>
                            <BoldStyledText style={storedCredentials.theme == 'light' ? LightStyles.modalHeaderText :  DarkStyles.modalHeaderText}> {strings().addingPlace} </BoldStyledText>
                            <TouchableOpacity style={storedCredentials.theme == 'light' ? LightStyles.modalHeaderInfoIconWrapper :  DarkStyles.modalHeaderInfoIconWrapper}>
                                <AntDesign name="infocirlceo" size={24} color="white" />
                            </TouchableOpacity>
                        </View>

                        <View style={storedCredentials.theme == 'light' ? LightStyles.modalBodyWrapper :  DarkStyles.modalBodyWrapper}>
                            <TouchableOpacity 
                                style={storedCredentials.theme == 'light' ? LightStyles.addBtn :  DarkStyles.addBtn} 
                                onPress={()=>{
                                    setModalVisible(!modalVisible);
                                    setManualAddRoomModalVisible(!manualAddRoomModalVisible);
                                }} 
                                >
                                <StyledText style={storedCredentials.theme == 'light' ? LightStyles.addBtnText :  DarkStyles.addBtnText}> {strings().manual} </StyledText>
                            </TouchableOpacity>
                            <TouchableOpacity 
                                style={storedCredentials.theme == 'light' ? LightStyles.addBtn :  DarkStyles.addBtn}
                                onPress={()=> {
                                    setModalVisible(!modalVisible);
                                    setRecieveRoomModalVisible(true);
                                    fetchRecieveCodeHandler();
                                    setIsFetchingRecieveCode(true);
                                }}
                            >
                                <StyledText style={storedCredentials.theme == 'light' ? LightStyles.addBtnText :  DarkStyles.addBtnText} > {strings().receive} </StyledText>
                            </TouchableOpacity>
                        </View>
                    </View>
                </View>

            </Modal>
            <Modal 
                animationType='slide'
                transparent={true}
                visible={manualAddRoomModalVisible}
                onRequestClose={()=> setManualAddRoomModalVisible(!manualAddRoomModalVisible)}
            >
                <View style={{flex: 1, flexDirection: 'column-reverse'}} >
                    <View style={storedCredentials.theme == 'light' ? LightStyles.manualAddRoomModalView :  DarkStyles.manualAddRoomModalView} >
                        <View style={{...storedCredentials.theme == 'light' ? LightStyles.manualAddRoomModalHeader :  DarkStyles.manualAddRoomModalHeader, ...storedCredentials.language == 'English' ? {flexDirection: 'row-reverse'} : {flexDirection: 'row'}}}>
                            <TouchableOpacity 
                                    style={{...storedCredentials.theme == 'light' ? LightStyles.modalHeaderCloseIconWrapper :  DarkStyles.modalHeaderCloseIconWrapper, ...{marginLeft: 15}}} 
                                    onPress={()=> setManualAddRoomModalVisible(!manualAddRoomModalVisible)}
                                >
                                    <AntDesign name="closecircleo" size={24} color="white" />                            
                            </TouchableOpacity>

                            <BoldStyledText style={{...storedCredentials.theme == 'light' ? LightStyles.modalHeaderText :  DarkStyles.modalHeaderText, ...{marginRight: 15}}} > {strings().addingPlace} </BoldStyledText>

                        </View>

                        <View style={storedCredentials.theme == 'light' ? LightStyles.manualAddRoomModalBody :  DarkStyles.manualAddRoomModalBody}>
                            <StyledText style={storedCredentials.theme == 'light' ? LightStyles.manualAddRoomInputNameLabel :  DarkStyles.manualAddRoomInputNameLabel} > {strings().roomName} </StyledText>
                            <TextInput style={storedCredentials.theme == 'light' ? LightStyles.manualAddRoomInputName :  DarkStyles.manualAddRoomInputName} onChangeText={(text)=> setNewRoomName(text)}  />
                        </View>

                        <View style={{...storedCredentials.theme == 'light' ? LightStyles.manualAddRoomFooter :  DarkStyles.manualAddRoomFooter, ...storedCredentials.language == 'English' && {flexDirection: 'row'}}}>
                            <TouchableOpacity 
                                style={storedCredentials.theme == 'light' ? LightStyles.manualAddRoomSubmitBtn :  DarkStyles.manualAddRoomSubmitBtn} 
                                onPress={handleAddNewRoom}    
                            >
                                <StyledText style={storedCredentials.theme == 'light' ? LightStyles.manualAddRoomSubmitBtnText :  DarkStyles.manualAddRoomSubmitBtnText}> {strings().add} </StyledText>
                            </TouchableOpacity>
                            <TouchableOpacity 
                                style={{...storedCredentials.theme == 'light' ? LightStyles.manualAddRoomSubmitBtn :  DarkStyles.manualAddRoomSubmitBtn, ...{backgroundColor: storedCredentials.theme == 'light' ? '#347399' : '#262623' }}} 
                                onPress={()=> setManualAddRoomModalVisible(!manualAddRoomModalVisible) }    
                                >
                                <StyledText style={storedCredentials.theme == 'light' ? LightStyles.manualAddRoomSubmitBtnText :  DarkStyles.manualAddRoomSubmitBtnText}> {strings().cancel} </StyledText>
                            </TouchableOpacity>
                        </View>
                    </View>
                </View>
            </Modal>
            <Modal 
                animationType = 'fade'
                transparent = {true}
                visible = {recieveRoomModalVisible}
            >
                <View style={{flex: 1, justifyContent: 'center'}}>
                    <View style={storedCredentials.theme == 'light' ? LightStyles.modalView :  DarkStyles.modalView}>
                        <View style={storedCredentials.theme == 'light' ? LightStyles.modalHeader :  DarkStyles.modalHeader}>
                            <TouchableOpacity 
                                style={storedCredentials.theme == 'light' ? LightStyles.modalHeaderCloseIconWrapper :  DarkStyles.modalHeaderCloseIconWrapper} 
                                onPress={()=> {
                                    removeRecieveCode();
                                    fetchUserRooms();
                                }}
                                >
                                <AntDesign name="closecircleo" size={24} color="white" />                            
                            </TouchableOpacity>
                            <StyledText style={storedCredentials.theme == 'light' ? LightStyles.modalHeaderText :  DarkStyles.modalHeaderText}> {strings().receive} </StyledText>
                            <TouchableOpacity style={storedCredentials.theme == 'light' ? LightStyles.modalHeaderInfoIconWrapper :  DarkStyles.modalHeaderInfoIconWrapper}>
                                <AntDesign name="infocirlceo" size={24} color="white" />
                            </TouchableOpacity>
                        </View>
                        {isFetchingRecieveCode ?
                            <View style={storedCredentials.theme == 'light' ? LightStyles.modalBodyWrapper :  DarkStyles.modalBodyWrapper}>
                                    <View style={{flexDirection: 'row-reverse'}}>
                                        <StyledText style={{fontSize: 24}}> {strings().fetchingReceiveCode} </StyledText>
                                        <ActivityIndicator size={'small'} />
                                    </View>
                            </View> 
                        :
                            <View style={{...storedCredentials.theme == 'light' ? LightStyles.modalBodyWrapper :  DarkStyles.modalBodyWrapper, ...{justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}}>
                                
                                <StyledText style={{fontSize: 30, fontWeight: 'bold', marginBottom: 15}}> {JSON.stringify(recieveCode)} </StyledText>
                                <StyledText> {strings().enterThisCodeToGetPlaces} </StyledText>
                            
                            </View> 
                        }
                        {/* {recieveCode &&
                            <View style={{...Styles.modalBodyWrapper, ...{justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}}>
                               
                                <Text style={{fontSize: 30, fontWeight: 'bold', marginBottom: 15}}> {JSON.stringify(recieveCode)} </Text>
                                <Text> برای دریافت مکان این کد را وارد کنید. </Text>
                                
                            </View> 
                        } */}
                    </View>
                </View>
            </Modal>
            <Modal 
                animationType = 'fade'
                transparent = {true}
                visible = {sendRoomModalVisible}
            >
                <View style={{flex: 1, justifyContent: 'center'}}>
                    <View style={storedCredentials.theme == 'light' ? LightStyles.modalView :  DarkStyles.modalView}>
                        <View style={storedCredentials.theme == 'light' ? LightStyles.modalHeader :  DarkStyles.modalHeader}>
                            <TouchableOpacity 
                                style={storedCredentials.theme == 'light' ? LightStyles.modalHeaderCloseIconWrapper :  DarkStyles.modalHeaderCloseIconWrapper} 
                                onPress={()=> {
                                    setSendRoomModalVisible(false);
                                }}
                                >
                                <AntDesign name="closecircleo" size={24} color="white" />                            
                            </TouchableOpacity>
                            <StyledText style={storedCredentials.theme == 'light' ? LightStyles.modalHeaderText :  DarkStyles.modalHeaderText}> ارسال مکان </StyledText>
                            <TouchableOpacity style={storedCredentials.theme == 'light' ? LightStyles.modalHeaderInfoIconWrapper :  DarkStyles.modalHeaderInfoIconWrapper}>
                                <AntDesign name="infocirlceo" size={24} color="white" />
                            </TouchableOpacity>
                        </View>
                        <View style={storedCredentials.theme == 'light' ? LightStyles.modalBodyWrapper :  DarkStyles.modalBodyWrapper}>
                            <View style={{flex: 1, alignItems: 'center'}}>
                                <TextInput 
                                    style={{backgroundColor: 'white', width: '100%', padding: 20, textAlign: 'center', borderRadius: 15, fontSize: 18, color: 'black'}}
                                    placeholder='کد 6 رقمی مقصد را وارد کنید' 
                                    keyboardType= 'numeric'
                                    onChangeText={value => setRecieveCode(value)}
                                />
                            
                                <TouchableOpacity 
                                    style={{marginTop: 25, backgroundColor: storedCredentials.theme == 'light' ? '#345b99' : '#8d8c84', paddingVertical: 15, paddingHorizontal: 40, borderRadius: 15}}
                                    onPress={() => {isSendingRooms ? {} : sendRoomHandler()}}    
                                >
                                    {
                                        isSendingRooms
                                        ?   <ActivityIndicator size={'large'} /> 
                                        :   <StyledText style={{fontSize: 22, color: 'white'}}> ارسال </StyledText>
                                    }
                                </TouchableOpacity>
                            </View>
                        </View> 

                    </View>
                </View>
            </Modal>

            {
                isEditingMode &&
                <View style={{flexDirection: 'row-reverse',justifyContent: 'center', paddingVertical: 10}}>
                    <TouchableOpacity 
                        style={{backgroundColor: storedCredentials.theme == 'light' ? '#4aa4db' : '#8d8c84' , padding: 10, marginHorizontal: 7, width: '40%', borderRadius: 15, alignItems: 'center' }}
                        onPress={() => {
                            setSendRoomModalVisible(true)
                        }}
                    >
                        <StyledText style={{fontSize: 19, fontWeight: '500', color: 'white'}}> {strings().share} </StyledText>
                    </TouchableOpacity>
                    <TouchableOpacity style={{backgroundColor: storedCredentials.theme == 'light' ? 'red' : '#7f7680', padding: 10, marginHorizontal: 7, width: '20%', borderRadius: 15, alignItems: 'center' }}
                        onPress={() => {isDeletingRooms ? {} : deleteRoomsHandler()}}
                    >
                        <StyledText style={{fontSize: 19, fontWeight: '500', color: 'white'}}> {strings().delete} </StyledText>
                    </TouchableOpacity>
                    <TouchableOpacity style={{backgroundColor: storedCredentials.theme == 'light' ? '#347399' : '#000000' , padding: 10, marginHorizontal: 7, width: '20%', borderRadius: 15, alignItems: 'center'}}
                        onPress={() => {
                            setIsEditingMode(!isEditingMode);
                            setSelectedItems([]);
                            setSelectedItemsHelper(1);
                        }}
                        
                    >
                        <StyledText style={{fontSize: 19, fontWeight: '500', color: 'white'}}> {strings().deny} </StyledText>
                    </TouchableOpacity>
                </View>
            }
            <FlatList
                style={storedCredentials.theme == 'light' ? LightStyles.flatlistStyle :  DarkStyles.flatlistStyle}
                data={rooms}
                showsVerticalScrollIndicator={false}
                keyExtractor={item => item.id}
                renderItem=
                {itemData => 
                    <Card 
                    style={{...storedCredentials.theme == 'light' ? LightStyles.card :  DarkStyles.card, ...storedCredentials.language == 'English' ? {flexDirection: 'row', } : {flexDirection: 'row-reverse'} }}
                    onPress={() => {isEditingMode ? toggleSelecteItem(itemData) : gotoRoomModulesHandler(itemData)}}    
                    onLongPress={() => {isEditingMode ? {} : toggleSelecteItem(itemData)}}
                    >
                        <View style={{justifyContent: 'center'}}>
                            <StyledText style={storedCredentials.theme == 'light' ? LightStyles.cardTitle :  DarkStyles.cardTitle}> {itemData.item.name} </StyledText>
                        </View>
                        {
                            selectedItems.findIndex(item => item == itemData.item.id) !== -1 
                            
                            ?
                                <View style={{justifyContent: 'center'}}>
                                    <Ionicons name="md-cloud-done-sharp" size={30} color={storedCredentials.theme == 'light' ? 'blue' : '#f2f2f1'} />

                                </View>
                            :
                                <View style={{justifyContent: 'center', maxWidth: '70%'}}>
                                    <FlatList 
                                        style={{flexDirection: 'row', flex: 1, justifyContent: 'flex-start', alignItems: 'flex-end' }}
                                        data={cardModulesArrHandler(itemData.item.id)}
                                        keyExtractor={item => item.MAC}
                                        // horizontal={true}
                                        renderItem=
                                        {moduleItem =>
                                            <View>
                                                {moduleItem.item.type == 'P' && 
                                                    <View>
                                                        {moduleItem.item.newState ?
                                                            <View style={{backgroundColor: moduleItem.item.newState == 0 ? '#fefefe' : '#f6fa72' , borderRadius: 20, justifyContent: 'center', alignItems: 'center', marginRight: 5, padding: 5}}>
                                                                <MaterialCommunityIcons name="power-plug-outline" size={20} color= "black" /> 
                                                            </View>
                                                            :
                                                            <View style={{backgroundColor: '#fefefe', borderRadius: 20, justifyContent: 'center', alignItems: 'center', marginRight: 5, padding: 5}}>
                                                                <MaterialCommunityIcons name="update" size={20} color="black" />
                                                            </View>
                                                            
                                                        }
                                                    </View>
                                                }
                                                {moduleItem.item.type == 'A1' && 
                                                    <View>
                                                        {moduleItem.item.newState ?
                                                            <View style={{backgroundColor: moduleItem.item.newState.PWR == 1 ? '#f6fa72' : '#fefefe', borderRadius: 20, justifyContent: 'center', alignItems: 'center', marginRight: 5, padding: 5}}>
                                                                <MaterialCommunityIcons name="fan" size={20} color= "black" /> 
                                                            </View>
                                                            :
                                                            <View style={{backgroundColor: '#fefefe', borderRadius: 20, justifyContent: 'center', alignItems: 'center', marginRight: 5, padding: 5}}>
                                                                <MaterialCommunityIcons name="update" size={20} color="black" />
                                                            </View>
                                                            
                                                        }
                                                    </View>
                                                }
                                                {moduleItem.item.type == 'A2' && 
                                                    <View>
                                                        {moduleItem.item.newState ?
                                                            <View style={{backgroundColor: moduleItem.item.newState.PWR == 1 ? '#f6fa72' : '#fefefe', borderRadius: 20, justifyContent: 'center', alignItems: 'center', marginRight: 5, padding: 5}}>
                                                                <MaterialCommunityIcons name="fan" size={20} color= "black" /> 
                                                            </View>
                                                            :
                                                            <View style={{backgroundColor: '#fefefe', borderRadius: 20, justifyContent: 'center', alignItems: 'center', marginRight: 5, padding: 5}}>
                                                                <MaterialCommunityIcons name="update" size={20} color="black" />
                                                            </View>
                                                            
                                                        }
                                                    </View>
                                                }
                                                {moduleItem.item.type == 'S1' && 
                                                    <View>
                                                        {moduleItem.item.newState ?
                                                            <View style={{backgroundColor: moduleItem.item.newState == 0 ? '#fefefe' : '#f6fa72' , borderRadius: 20, justifyContent: 'center', alignItems: 'center', marginRight: 5, padding: 5}}>
                                                                <AntDesign name="bulb1" size={20} color= "black" /> 
                                                            </View>
                                                            :
                                                            <View style={{backgroundColor: '#fefefe', borderRadius: 20, justifyContent: 'center', alignItems: 'center', marginRight: 5, padding: 5}}>
                                                                <MaterialCommunityIcons name="update" size={20} color="black" />
                                                            </View>
                                                            
                                                        }
                                                    </View>
                                                }
                                                {moduleItem.item.type == 'S2' && 
                                                    <View>
                                                        {moduleItem.item.newState ?
                                                            <View style={{backgroundColor: moduleItem.item.newState == 0 ? '#fefefe' : '#f6fa72' , borderRadius: 20, justifyContent: 'center', alignItems: 'center', marginRight: 5, padding: 5}}>
                                                                <AntDesign name="bulb1" size={20} color= "black" /> 
                                                            </View>
                                                            :
                                                            <View style={{backgroundColor: '#fefefe', borderRadius: 20, justifyContent: 'center', alignItems: 'center', marginRight: 5, padding: 5}}>
                                                                <MaterialCommunityIcons name="update" size={20} color="black" />
                                                            </View>
                                                            
                                                        }
                                                    </View>
                                                }
                                                {moduleItem.item.type == 'S3' && 
                                                    <View>
                                                        {moduleItem.item.newState ?
                                                            <View style={{backgroundColor: moduleItem.item.newState == 0 ? '#fefefe' : '#f6fa72' , borderRadius: 20, justifyContent: 'center', alignItems: 'center', marginRight: 5, padding: 5}}>
                                                                <AntDesign name="bulb1" size={20} color= "black" /> 
                                                            </View>
                                                            :
                                                            <View style={{backgroundColor: '#fefefe', borderRadius: 20, justifyContent: 'center', alignItems: 'center', marginRight: 5, padding: 5}}>
                                                                <MaterialCommunityIcons name="update" size={20} color="black" />
                                                            </View>
                                                            
                                                        }
                                                    </View>
                                                }
                                                {moduleItem.item.type == 'S4' && 
                                                    <View>
                                                        {moduleItem.item.newState ?
                                                            <View style={{backgroundColor: moduleItem.item.newState == 0 ? '#fefefe' : '#f6fa72' , borderRadius: 20, justifyContent: 'center', alignItems: 'center', marginRight: 5, padding: 5}}>
                                                                <AntDesign name="bulb1" size={20} color= "black" /> 
                                                            </View>
                                                            :
                                                            <View style={{backgroundColor: '#fefefe', borderRadius: 20, justifyContent: 'center', alignItems: 'center', marginRight: 5, padding: 5}}>
                                                                <MaterialCommunityIcons name="update" size={20} color="black" />
                                                            </View>
                                                            
                                                        }
                                                    </View>
                                                }
                                            </View>

                                        }
                                    />
                                </View>
                        }
                    </Card>
                }
                
            >
            </FlatList>

        </View>
    )
};

let DarkStyles = {
    dropdownModalWrapper: {
        backgroundColor: '#b3b2ad', 
        padding: 10, 
        width: '50%', 
        marginRight: 15, 
        borderRadius: 15
    },
    wrapper:{
        flex: 1,
        justifyContent: 'space-between',
        backgroundColor: '#3b3c37'
    },
    flatlistStyle:{ 
    },
    card:{
        justifyContent: 'space-between',
        height: 100,
        backgroundColor: '#807f76',
        width: '90%',
        alignSelf: 'center',
        // flexDirection: 'row-reverse',
        paddingBottom: 10
    },
    cardTitle:{
        fontSize: 30,
        textAlign: 'right',
        color: 'white'
    },
    addRoomCard:{
        backgroundColor: '#ffffff',
        height: 100,
        alignItems:'center',
        justifyContent:'center',
        width: '90%',
        alignSelf: 'center'
    },
    modalView:{
        marginVertical: 10,
        marginHorizontal: '10%',
        backgroundColor: "white",
        borderRadius: 20,
        shadowColor: "#000",
        shadowOffset: {
          width: 0,
          height: 2
        },
        shadowOpacity: 0.25,
        shadowRadius: 4,
        elevation: 5,
    },
    modalHeader:{
        flexDirection: 'row-reverse',
        justifyContent: 'space-between',
        paddingVertical: 15,
        backgroundColor: '#2b2b28',
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20
    },
    modalHeaderCloseIconWrapper:{
        paddingRight: 15,
        paddingVertical: 10
    },
    modalHeaderInfoIconWrapper:{
        paddingLeft: 15,
        paddingVertical: 10
    },
    modalHeaderText:{
        fontSize: 25,
        fontWeight: '600',
        color: 'white',
    },
    modalBodyWrapper:{
        flexDirection: 'row-reverse',
        paddingVertical:30,
        paddingHorizontal: 20,
        justifyContent: 'space-between' ,
        backgroundColor: '#b3b2ad',
        borderBottomLeftRadius: 20,
        borderBottomRightRadius: 20
    },  
    addBtn:{
        backgroundColor: '#807f76',
        width: '45%',
        justifyContent: 'center',
        alignItems: 'center',
        paddingVertical: 20,
        borderRadius: 20,
        elevation: 3,
    },
    addBtnText:{
        color: 'white',
        fontSize: 18,
    },
    manualAddRoomModalView:{
        backgroundColor: "white",
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20,
        shadowColor: "#000",
        shadowOffset: {
          width: 0,
          height: 2
        },
        shadowOpacity: 0.25,
        shadowRadius: 4,
        elevation: 5,
        minHeight: '70%',
        marginHorizontal: 10
    }, 
    manualAddRoomModalHeader:{
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingVertical: 15,
        backgroundColor: '#2b2b28',
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20,
        padding: 7
    },
    manualAddRoomModalBody:{
        flex: 1,
        padding: 20,
        backgroundColor: '#b3b2ad'
    },
    manualAddRoomInputNameLabel:{
        fontSize: 24,
        fontWeight: '300',
        color: 'white'
    },
    manualAddRoomInputName:{
        backgroundColor: '#F5F6FA',
        borderRadius: 20,
        padding:20,
        margin: 5,
        fontSize: 22,
        marginTop: 20
    },  
    manualAddRoomFooter:{
        flexDirection: 'row-reverse',
        justifyContent: 'space-around',
        backgroundColor: '#b3b2ad'
    },
    manualAddRoomSubmitBtn:{
        backgroundColor: '#807f76',
        width: '40%',
        margin: 20,
        padding: 20,
        paddingVertical: 15,
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 20
    },
    manualAddRoomSubmitBtnText:{
        fontSize: 24,
        fontWeight: '600',
        color: 'white'
    },
    modalInputWrapper:{
        flexDirection: 'row-reverse',
        justifyContent: 'flex-start' ,
        marginHorizontal: 15,
        marginVertical:5,
        padding: 10,
        alignItems:'center'
    },
    newRoomNameInputBox:{
        backgroundColor: '#F5F6FA',
        borderBottomWidth: 1,
        borderBottomColor: 'gray',
        flex:1,
        padding: 10,
    },
    newRoomNameInputLabel:{
        fontSize: 20,
        fontWeight: '300'
    },
};


let LightStyles = {
    dropdownModalWrapper: {
        backgroundColor: 'pink', 
        padding: 10, 
        width: '50%', 
        marginRight: 15, 
        borderRadius: 15
    },
    wrapper:{
        flex: 1,
        justifyContent: 'space-between',
    },
    flatlistStyle:{ 
    },
    card:{
        justifyContent: 'space-between',
        height: 100,
        backgroundColor: 'white',
        width: '90%',
        alignSelf: 'center',
        // flexDirection: 'row-reverse',
        paddingBottom: 10
    },
    cardTitle:{
        fontSize: 30,
        textAlign: 'right',
        color: 'black'
    },
    addRoomCard:{
        backgroundColor: '#ffffff',
        height: 100,
        alignItems:'center',
        justifyContent:'center',
        width: '90%',
        alignSelf: 'center'
    },
    modalView:{
        marginVertical: 10,
        marginHorizontal: '10%',
        backgroundColor: "white",
        borderRadius: 20,
        shadowColor: "#000",
        shadowOffset: {
          width: 0,
          height: 2
        },
        shadowOpacity: 0.25,
        shadowRadius: 4,
        elevation: 5,
    },
    modalHeader:{
        flexDirection: 'row-reverse',
        justifyContent: 'space-between',
        paddingVertical: 15,
        backgroundColor: '#4aa4db',
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20
    },
    modalHeaderCloseIconWrapper:{
        paddingRight: 15,
        paddingVertical: 10
    },
    modalHeaderInfoIconWrapper:{
        paddingLeft: 15,
        paddingVertical: 10
    },
    modalHeaderText:{
        fontSize: 25,
        fontWeight: '600',
        color: 'white',
    },
    modalBodyWrapper:{
        flexDirection: 'row-reverse',
        paddingVertical:30,
        paddingHorizontal: 20,
        justifyContent: 'space-between' ,
        backgroundColor: '#abdfff',
        borderBottomLeftRadius: 20,
        borderBottomRightRadius: 20
    },  
    addBtn:{
        backgroundColor: 'white',
        width: '45%',
        justifyContent: 'center',
        alignItems: 'center',
        paddingVertical: 20,
        borderRadius: 20,
        elevation: 3,
    },
    addBtnText:{
        color: 'black',
        fontSize: 18,
    },
    manualAddRoomModalView:{
        backgroundColor: "white",
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20,
        shadowColor: "#000",
        shadowOffset: {
          width: 0,
          height: 2
        },
        shadowOpacity: 0.25,
        shadowRadius: 4,
        elevation: 5,
        minHeight: '70%',
        marginHorizontal: 10
    }, 
    manualAddRoomModalHeader:{
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingVertical: 15,
        backgroundColor: '#4aa4db',
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20
    },
    manualAddRoomModalBody:{
        flex: 1,
        padding: 20,
        backgroundColor: '#abdfff'
    },
    manualAddRoomInputNameLabel:{
        fontSize: 24,
        fontWeight: '300',
    },
    manualAddRoomInputName:{
        backgroundColor: '#F5F6FA',
        borderRadius: 20,
        padding:20,
        margin: 5,
        fontSize: 22,
        marginTop: 20
    },  
    manualAddRoomFooter:{
        flexDirection: 'row-reverse',
        justifyContent: 'space-around',
        backgroundColor: '#abdfff'
    },
    manualAddRoomSubmitBtn:{
        backgroundColor: '#d5efff',
        width: '40%',
        margin: 20,
        padding: 20,
        paddingVertical: 15,
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 20
    },
    manualAddRoomSubmitBtnText:{
        fontSize: 24,
        fontWeight: '600',
        color: 'black'
    },
    modalInputWrapper:{
        flexDirection: 'row-reverse',
        justifyContent: 'flex-start' ,
        marginHorizontal: 15,
        marginVertical:5,
        padding: 10,
        alignItems:'center'
    },
    newRoomNameInputBox:{
        backgroundColor: '#F5F6FA',
        borderBottomWidth: 1,
        borderBottomColor: 'gray',
        flex:1,
        padding: 10,
    },
    newRoomNameInputLabel:{
        fontSize: 20,
        fontWeight: '300'
    },
};

// const Styles = StyleSheet.create({
//     wrapper:{
//         flex: 1,
//         justifyContent: 'space-between',
//     },
//     flatlistStyle:{ 
//     },
//     card:{
//         justifyContent: 'space-between',
//         height: 100,
//         backgroundColor: 'white',
//         width: '90%',
//         alignSelf: 'center',
//         flexDirection: 'row-reverse',

//     },
//     cardTitle:{
//         fontWeight: 'bold',
//         fontSize: 30,
//         textAlign: 'right',
//         color: 'black'
//     },
//     addRoomCard:{
//         backgroundColor: '#ffffff',
//         height: 100,
//         alignItems:'center',
//         justifyContent:'center',
//         width: '90%',
//         alignSelf: 'center'
//     },
//     modalView:{
//         marginVertical: 10,
//         marginHorizontal: '10%',
//         backgroundColor: "white",
//         borderRadius: 20,
//         shadowColor: "#000",
//         shadowOffset: {
//           width: 0,
//           height: 2
//         },
//         shadowOpacity: 0.25,
//         shadowRadius: 4,
//         elevation: 5,
//     },
//     modalHeader:{
//         flexDirection: 'row-reverse',
//         justifyContent: 'space-between',
//         paddingVertical: 15,
//         backgroundColor: '#4aa4db',
//         borderTopLeftRadius: 20,
//         borderTopRightRadius: 20
//     },
//     modalHeaderCloseIconWrapper:{
//         paddingRight: 15,
//         paddingVertical: 10
//     },
//     modalHeaderInfoIconWrapper:{
//         paddingLeft: 15,
//         paddingVertical: 10
//     },
//     modalHeaderText:{
//         fontSize: 30,
//         fontWeight: '800',
//         color: 'white',
//     },
//     modalBodyWrapper:{
//         flexDirection: 'row-reverse',
//         paddingVertical:30,
//         paddingHorizontal: 20,
//         justifyContent: 'space-between' ,
//         backgroundColor: '#abdfff',
//         borderBottomLeftRadius: 20,
//         borderBottomRightRadius: 20
//     },  
//     addBtn:{
//         backgroundColor: 'white',
//         width: '45%',
//         justifyContent: 'center',
//         alignItems: 'center',
//         paddingVertical: 20,
//         borderRadius: 20,
//         elevation: 3,
//     },
//     addBtnText:{
//         color: 'black',
//         fontSize: 22,
//         fontWeight: 'bold'
//     },
//     manualAddRoomModalView:{
//         backgroundColor: "white",
//         borderTopLeftRadius: 20,
//         borderTopRightRadius: 20,
//         shadowColor: "#000",
//         shadowOffset: {
//           width: 0,
//           height: 2
//         },
//         shadowOpacity: 0.25,
//         shadowRadius: 4,
//         elevation: 5,
//         minHeight: '70%',
//         marginHorizontal: 10
//     }, 
//     manualAddRoomModalHeader:{
//         flexDirection: 'row',
//         justifyContent: 'space-between',
//         paddingVertical: 15,
//         backgroundColor: '#4aa4db',
//         borderTopLeftRadius: 20,
//         borderTopRightRadius: 20
//     },
//     manualAddRoomModalBody:{
//         flex: 1,
//         padding: 20,
//         backgroundColor: '#abdfff'
//     },
//     manualAddRoomInputNameLabel:{
//         fontSize: 24,
//         fontWeight: '300',
//     },
//     manualAddRoomInputName:{
//         backgroundColor: '#F5F6FA',
//         borderRadius: 20,
//         padding:20,
//         margin: 5,
//         fontSize: 22,
//         marginTop: 20
//     },  
//     manualAddRoomFooter:{
//         flexDirection: 'row-reverse',
//         justifyContent: 'space-around',
//         backgroundColor: '#abdfff'
//     },
//     manualAddRoomSubmitBtn:{
//         backgroundColor: '#d5efff',
//         width: '40%',
//         margin: 20,
//         padding: 20,
//         paddingVertical: 15,
//         alignItems: 'center',
//         justifyContent: 'center',
//         borderRadius: 20
//     },
//     manualAddRoomSubmitBtnText:{
//         fontSize: 24,
//         fontWeight: '600',
//         color: 'black'
//     },
//     modalInputWrapper:{
//         flexDirection: 'row-reverse',
//         justifyContent: 'flex-start' ,
//         marginHorizontal: 15,
//         marginVertical:5,
//         padding: 10,
//         alignItems:'center'
//     },
//     newRoomNameInputBox:{
//         backgroundColor: '#F5F6FA',
//         borderBottomWidth: 1,
//         borderBottomColor: 'gray',
//         flex:1,
//         padding: 10,
//     },
//     newRoomNameInputLabel:{
//         fontSize: 20,
//         fontWeight: '300'
//     },
// })
export default Home;
